(function($) {
        $.fn.newPasswordRequirments = function(form) {
            form.keyup(function() {
                var password = $('#new_password').val();
                if (password.length < 8) {
                    $('#check-minlength').removeClass('valid').addClass('invalid');
                } else {
                    $('#check-minlength').removeClass('invalid').addClass('valid');
                };

                if (password.match(/[a-z]/)) {
                    $('#check-lowercase').removeClass('invalid').addClass('valid');
                } else {
                    $('#check-lowercase').removeClass('valid').addClass('invalid');
                };

                if (password.match(/[A-Z]/)) {
                    $('#check-uppercase').removeClass('invalid').addClass('valid');
                } else {
                    $('#check-uppercase').removeClass('valid').addClass('invalid');
                };

                if (password.match(/\d/)) {
                    $('#check-number').removeClass('invalid').addClass('valid');
                } else {
                    $('#check-number').removeClass('valid').addClass('invalid');
                };

                if (password.match(/([!$#%&£]+)/)) {
                    $('#check-special').removeClass('invalid').addClass('valid');
                } else {
                    $('#check-special').removeClass('valid').addClass('invalid');
                };
            });
        }

}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/new-password-requirments.js